import { createRoot } from 'react-dom/client';
import { SgwtAuthenticationProvider, type SGWTWidgetConfiguration } from '@sgwt/react-shared-libs';
import {
  type SgBootstrapTheme,
  SgwtConnect,
  SgwtSplashScreen,
  SgwtWebAnalytics,
  SgwtWidgetContextProvider,
} from '@sgwt/sgwt-widgets-react';
import './axios.config';
import './sgwt-widgets';
import App from './components/App/App';
import { type GlobalConfiguration } from './config.type';
import { UserPermissions } from './types';
import { v4 as uuidv4 } from 'uuid';

declare global {
  var SGWTWidgetConfiguration: SGWTWidgetConfiguration;
  var globalConfiguration: GlobalConfiguration;
  var loadSgBootstrap: (theme: SgBootstrapTheme) => void;
}

// Polyfill for crypto.randomUUID is needed for sgwt-chatbot widget
if (!globalThis.crypto.randomUUID) {
  globalThis.crypto.randomUUID = (() => uuidv4()) as typeof globalThis.crypto.randomUUID;
}

const elt = document.querySelector('#root');
if (elt) {
  const config = window.globalConfiguration;
  const root = createRoot(elt);

  root.render(
    <SgwtWidgetContextProvider infrastructure="azure">
      <SgwtConnect
        clientId={config.sgConnect.clientId}
        authorizationEndpoint={config.sgConnect.endpoint}
        scope={config.sgConnect.scope}
        redirectUri="/silent-renew.html"
      />

      <SgwtAuthenticationProvider
        autoSignIn
        withSgmServiceLoader
        navigationAs={{
          allowPermissionChange: true,
          allowUserChange: true,
          persistence: 'session',
          listOfPermissions: [
            UserPermissions.ADMIN,
            UserPermissions.ARCHITECT,
            UserPermissions.MODERATOR,
            UserPermissions.AUDITOR,
            UserPermissions.REVIEWER,
          ],
        }}>
        <App />
      </SgwtAuthenticationProvider>

      <SgwtSplashScreen applicationId="modernization" />
      <SgwtWebAnalytics
        siteId={config.matomo.siteId}
        baseUrl={config.matomo.server}
        apmRumEnabled={config.rum.activate}
        apmRumServerurl={config.rum.serverURL}
        apmRumServiceName={config.rum.serviceName}
      />
    </SgwtWidgetContextProvider>
  );
}
